<template>
  <v-alert
    v-model="isActive"
    :dismissible="dismissible"
    :type="type"
    :icon="icon"
    :outline="outline"
  >
    {{ message }}
  </v-alert>
</template>

<script>
export default {
  props: {
    dismissible: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'success'
    },
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: [String, undefined],
      default: undefined
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isActive: true
  })
}
</script>
